module.exports = __webpack_public_path__ + "static/media/earth-eco-ecology-svgrepo-com.1e92fcd3.svg";